import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
//components
import Title from 'components/backoffice/texts/title';
import DeliveriesForm from 'components/backoffice/forms/deliveriesForm';

const CreateDeliveries = () => {
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  useEffect(() => {
    setTitle(t('createdelivery'))
    return () => {
      setTitle('');
    }
  }, [setTitle])

  return (
    <>
      <Title text={t('createdelivery')} />
      <DeliveriesForm />
    </>
  );
};

export default CreateDeliveries;
